import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import {
  ListItemStyled,
  ListItemTitleStyled,
  ListItemHeaderStyled,
  TitleContainerStyled,
} from "./styles";

import { iconServiceType } from "helpers/getIcon";

// action creator
import { openOrder, closeOrder } from "redux/ducks/ordersHistory";

const HistoryMapRow = ({ item, colorRGB, isOpen = false }) => {
  const dispatch = useDispatch();
  const handleOpen = useCallback((id) => dispatch(openOrder(id)), [dispatch]);
  const handleClose = useCallback((id) => dispatch(closeOrder(id)), [dispatch]);
  return (
    <>
      <ListItemStyled
        className={isOpen ? "active-row-light" : ""}
        onClick={() => (!isOpen ? handleOpen(item.id) : handleClose(item.id))}
      >
        <ListItemHeaderStyled position="space-around" aling="flex-start">
          <TitleContainerStyled>
            <img
              width="45"
              src={iconServiceType(item.account)}
              alt="Imagen orden"
            />
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Cliente:</ListItemTitleStyled>
            <span>{item.customer}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Cuenta:</ListItemTitleStyled>
            <span>{item.account}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Nombre:</ListItemTitleStyled>
            <span>{item.customerName}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>
              Telefono:
            </ListItemTitleStyled>
            <span>{item.phone}</span>
          </TitleContainerStyled>
        </ListItemHeaderStyled>
        <ListItemHeaderStyled position="space-around">
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Tipo:</ListItemTitleStyled>
            <span>{item.type}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Folio:</ListItemTitleStyled>
            <span>{item.folio}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>
              Cant. surtida:
            </ListItemTitleStyled>
            <span>{item.quantity}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Monto:</ListItemTitleStyled>
            <span>{item.total}</span>
          </TitleContainerStyled>
        </ListItemHeaderStyled>
        <ListItemHeaderStyled position="space-around">
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>
              Fecha Programacion:
            </ListItemTitleStyled>
            <span>{item.programDate}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Estatus:</ListItemTitleStyled>
            <span>{item.status}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Planta:</ListItemTitleStyled>
            <span>{item.station}</span>
          </TitleContainerStyled>
          <TitleContainerStyled>
            <ListItemTitleStyled color={colorRGB}>Unidad:</ListItemTitleStyled>
            <span>{item.unit}</span>
          </TitleContainerStyled>
        </ListItemHeaderStyled>
      </ListItemStyled>
    </>
  );
};

export default React.memo(HistoryMapRow);
